import { Prisma } from '@prisma/client';
import axiosInstance from '../api';

const uploadsService = {
  find: async (listingId: string, token?: string) => {
    const params: any = { listingId };
    if (token) {
      params.token = token;
    }
    const res = await axiosInstance.get('/uploads', { params });
    return res.data;
  },
  create: async (data: any) => {
    const res = await axiosInstance.post('/uploads', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  },
  patch: async (id: string, data: Prisma.uploadsUpdateInput) => {
    const res = await axiosInstance.patch(`/uploads/${id}`, data);
    return res.data;
  },
};

export default uploadsService;
